<app-header></app-header>
<main class="main">
  <router-outlet></router-outlet>

<div
  class="position-fixed bottom-0 end-0 m-3 mb-5 p-3 bg-white border rounded-3 shadow-lg"
  id="cookiePopup"
  *ngIf="showPopup"
  style="width: 320px; z-index: 1050;"
  data-aos="fade-up" data-aos-delay="500"
>
  <h5 class="mb-2">Wir verwenden Cookies</h5>
  <p class="mb-3 small text-secondary">
    Wir verwenden Cookies, um Ihr Surferlebnis zu verbessern. Lesen Sie unsere
    <a routerLink="/Privacy" (click)="close()">Datenschutzerklärung</a>.
  </p>
  <div class="d-flex justify-content-between">
    <button class="btn btn-primary btn-sm" (click)="accept()">Akzeptieren</button>
    <button class="btn btn-outline-secondary btn-sm" (click)="decline()">Nicht mehr anzeigen</button>
  </div>
</div>



</main>
<app-footer></app-footer>